import React from "react";
import { Box, Typography } from "@mui/material";

export default function PageHeader({ title, subTitle, children }) {
    return (
        <Box mb={4} mt={4}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Box>
                    <Typography variant="h4">{title}</Typography>
                    <Typography variant="subtitle1" color="primary" >{subTitle}</Typography>
                </Box>
                <Box>
                    {children}
                </Box>
            </div>
        </Box>
    )
}